export const SET_DATA_MODELS = 'dataModel//SET_DATA_MODELS'

interface GenericObject {
  [key: string]: any
}

interface DataModelsState {
  data: GenericObject
}

interface DataModelsStore {
  dataModel: DataModelsState
}

interface DataModelsAction {
  type: string
  payload?: GenericObject
}

export function setDataModels(data: GenericObject): DataModelsAction {
  return {
    type: SET_DATA_MODELS,
    payload: data,
  }
}

export function getDataModels(store: DataModelsStore): GenericObject {
  return store.dataModel.data
}

const initialState: DataModelsState = {
  data: {},
}

export default function dataModelsReducer(
  state: DataModelsState = initialState,
  action: DataModelsAction,
): DataModelsState {
  switch (action.type) {
    case SET_DATA_MODELS:
      return {
        ...state,
        data: action.payload || {},
      }

    default:
      return state
  }
}
